/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.confirmation-dialog {
  .content {
    background-color: variables.$color-corpuls-system-yellow-reduced;
    padding: variables.$padding-medium;
    align-items: center;

    svg {
      fill: variables.$color-corpuls-system-yellow;
    }
  }
}
